import { toast } from "./toast";
/**
 * Upload several files through a single-file uploader, one after another.
 *
 * Sequential on purpose: the upload endpoints take one file each, and the
 * per-parent endpoints return the parent's updated state, so running them in
 * parallel would race those responses against each other.
 *
 * ⚠️ One failed file never stops the rest — it is collected and reported, so
 * picking ten files where one is rejected still attaches the other nine.
 *
 * @param files      FileList | File[]
 * @param uploadOne  async (file) => result
 * @returns { results: [result], failed: [{ name, reason }] }
 */
export async function uploadFiles(files, uploadOne) {
  const list = Array.from(files || []);
  const results = [];
  const failed = [];
  for (const file of list) {
    try {
      results.push(await uploadOne(file));
    } catch (err) {
      failed.push({
        name: file?.name || "file",
        reason: err?.response?.data?.detail || err?.message || "upload failed",
      });
    }
  }
  return { results, failed };
}

/** One warning toast summarising every file that failed. */
export function alertUploadFailures(failed) {
  if (!failed?.length) return;
  toast.warning(
    `Failed to upload ${failed.length} file(s):\n` +
      failed.map((f) => `• ${f.name} — ${f.reason}`).join("\n")
  );
}
